module.exports = __webpack_public_path__ + "img/FAPI-JNU.d2f7c6f6.png";